import { useEffect, useState } from 'react';
import { auth } from '../config/firebase';

/**
 * The signed-in member according to Firebase, and whether we know yet.
 *
 * Use this — never `Cookies.get('uid')` — anywhere a decision depends on
 * someone actually being signed in. The uid cookie outlives the Firebase
 * session, so a stale one reads as signed-in to every check that trusts it,
 * including the ones standing in front of the card form.
 *
 * `loading` means "not decided yet", not "signed out". Firebase restores the
 * session asynchronously on a hard page load, and a gate that treats that
 * gap as signed-out bounces members off their own checkout on refresh.
 * Render a spinner while it is true; decide only once it is false.
 *
 * @returns {{user: Object|null, loading: boolean}}
 */
export default function useFirebaseUser() {
  const [state, setState] = useState({ user: null, loading: true });

  // onAuthStateChanged returns its own unsubscribe, which is exactly what
  // the effect cleanup wants.
  useEffect(() => auth.onAuthStateChanged((user) => setState({ user, loading: false })), []);

  return state;
}
